import { useQuery } from "react-query";

import { makeRequest } from "@/util";
import { GetAccessReponse } from "../types";

export const useAccountEntitlements = () => {
  return useQuery("useAccountEntitlements", async () => {
    const { data: res } = await makeRequest<GetAccessReponse>(
      "get_account_entitlements",
    );
    return res;
  });
};
